import React, { FC, useEffect, useRef } from 'react';
import { SelectPicker } from 'rsuite';
import clsx from 'clsx';
import { FilterComponent } from '../FilterComponent';
import { usePaymentContext } from '../../store/payments/payments-context';
import { useLocation } from 'react-router';
import { makeSearchParams, parseSearchParams } from '../../utils/utilities';
import { useNavigate } from 'react-router-dom';

export interface IFinancialAccountProps {
  relatedEntityType?: string;
  pageSize?: string;
  pageNumber?: string;
}

interface Props {
  relatedEntityType: string;
  setRelatedEntityType: (type: string) => void;
}

export const FinancialAccountFilterSection: FC<Props> = (props) => {
  const { relatedEntityType, setRelatedEntityType } = props;

  const isMounted = useRef(false);
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const { paymentContextState } = usePaymentContext();
  const { entityTypesList } = paymentContextState;

  const filtersFromUrl: IFinancialAccountProps = parseSearchParams(search) || {};

  useEffect(() => {
    if (!isMounted.current) return;

    const params: IFinancialAccountProps = { ...filtersFromUrl };
    params.relatedEntityType = relatedEntityType;

    navigate(`${pathname}?${makeSearchParams(params)}`);
  }, [relatedEntityType]);


  useEffect(() => {
    if (!isMounted.current) {
      // first mount
      isMounted.current = true;
    }
  }, []);

  return (
    <div className="d-flex align-items-center fc-filter-line">
      <FilterComponent value={relatedEntityType} label="Entity type" labelPlacement="integrated">
        <SelectPicker
          data={entityTypesList}
          appearance="subtle"
          placement="bottomEnd"
          placeholder="Entity type"
          onSelect={(type): void => setRelatedEntityType(type)}
          className={clsx('fc-selector timezone-selector', relatedEntityType ? 'fc-selector-cleanable' : 'fc-added-icon')}
          onClean={(): void => setRelatedEntityType('')}
          searchable={false}
          value={relatedEntityType}
        />
      </FilterComponent>
    </div>
  );
};